import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function PaymentSuccessPage() {
    const { userProfile } = useAuth();

    useEffect(() => {
        // CORREÇÃO: Limpar plano pendente do localStorage após sucesso
        localStorage.removeItem('pendingPlan');
        // Opcional: Atualizar dados do usuário
        // window.location.reload(); // Ou buscar novamente do Firestore
    }, []);

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <div style={styles.iconSuccess}>
                    <i className="bi bi-check-circle-fill" style={{ fontSize: '4rem' }}></i>
                </div>

                <h1 style={styles.title}>Pagamento Aprovado!</h1>

                <p style={styles.message}>
                    Seu pagamento foi processado com sucesso e seu plano <strong>{userProfile?.plan}</strong> está ativo!
                </p>

                <div style={styles.info}>
                    <p><i className="bi bi-check-circle-fill text-success me-2"></i>Assinatura ativada</p>
                    <p><i className="bi bi-check-circle-fill text-success me-2"></i>Acesso completo aos recursos</p>
                    <p><i className="bi bi-check-circle-fill text-success me-2"></i>Você receberá um email de confirmação</p>
                </div>

                <Link to="/dashboard" style={styles.button}>
                    Ir para o Dashboard
                </Link>

                <Link to="/assinatura" style={styles.linkSecondary}>
                    Ver detalhes da assinatura
                </Link>
            </div>
        </div>
    );
}

const styles = {
    container: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '2rem',
    },
    card: {
        background: 'white',
        borderRadius: '16px',
        padding: '3rem',
        maxWidth: '500px',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
    },
    iconSuccess: {
        color: '#48bb78',
        marginBottom: '1.5rem',
    },
    title: {
        fontSize: '2rem',
        fontWeight: '700',
        color: '#2d3748',
        marginBottom: '1rem',
    },
    message: {
        fontSize: '1.1rem',
        color: '#718096',
        marginBottom: '2rem',
        lineHeight: '1.6',
    },
    info: {
        background: '#f0fdf4',
        border: '1px solid #86efac',
        borderRadius: '12px',
        padding: '1.5rem',
        marginBottom: '2rem',
        textAlign: 'left',
    },
    button: {
        display: 'inline-block',
        padding: '1rem 2rem',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        textDecoration: 'none',
        borderRadius: '8px',
        fontWeight: '600',
        fontSize: '1.1rem',
        marginBottom: '1rem',
    },
    linkSecondary: {
        display: 'block',
        color: '#667eea',
        textDecoration: 'none',
        marginTop: '1rem',
    },
};

export default PaymentSuccessPage;
